class BESSAppRegister extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.page-register');
        if (this.root.length === 0) {
            return;
        }

        this.registerMain = $('.app-register-main');
        this.registerSuccess = $('.app-register-success');

        this.passwordsDontMatchWarning = $('.app-passwords-dont-match');
        this.registrationFailedWarning = $('.app-registration-failed');

        this.inputs = {
            email: getMaterialTextControl('email'),
            name: getMaterialTextControl('name'),
            organisation: getMaterialTextControl('organisation'),
            password1: getMaterialTextControl('password1'),
            password2: getMaterialTextControl('password2'),
            //industry: getMaterialTextControl('industry'),
            role: getMaterialTextControl('role'),
            receiveEmailUpdates: getMaterialTextControl('receive_email_updates'),
            captcha: $('#id_captcha'),
        }

        this.registerBtn = this.root.find('.app-register');

        this.form = this.root.find('form');
        this.form.submit(this.#onDoCapcha.bind(this));
    }

    #onDoCapcha(e) {
        let siteKey = '6LdSveAjAAAAAC17fLcmMQu6mvpKzxzd1i2XtZWo'
        e.preventDefault();
        $.getScript("https://www.google.com/recaptcha/api.js?render=" + siteKey, function () {
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, {action: 'submit'}).then(function (token) {
                    this.token = token;
                    this.#onRegisterUser(e);
                }.bind(this));
            }.bind(this));
        }.bind(this));
        return false;
    }

    #onRegisterUser(e) {
        e.preventDefault();
        let password = this.inputs.password1.val();
        let confirmPassword = this.inputs.password2.val();
        let passwordsMatch = password === confirmPassword;
        this.passwordsDontMatchWarning.showIf(!passwordsMatch);
        if (passwordsMatch) {
            this.registrationFailedWarning.hide();
            this.registerBtn.disableControl();
            this.registerBtn.addClass('app-saving');

            BESSApp.instance.services.api.auth.registerUser(
                this.inputs.email.val().trim(),
                this.inputs.name.val().trim(),
                this.inputs.organisation.val().trim(),
                password,
                this.inputs.receiveEmailUpdates.isChecked(),
                //this.inputs.industry.val(),
                this.inputs.role.val(),
                this.token,
                this.#onRegistered.bind(this),
                this.#onRegisterFailure.bind(this),
            );
        }
        return false;
    }

    #onRegistered() {
        this.registerMain.hide();
        this.registerSuccess.removeClass('hidden').fadeIn();
    }

    #onRegisterFailure(reason) {
        this.registrationFailedWarning.text(reason).showIf(true);
        this.registerBtn.enableControl();
        this.registerBtn.removeClass('app-saving');
    }
}